export class DealerInfo {
  public accountNumber?: number;
  public companyName?: string;
  public commissionCode?: number;
  public branchPlant?: string;
  public companyCode?: string;
  public type?: string;
  constructor(
    accountNumber?: number,
    companyName?: string,
    commissionCode?: number,
    branchPlant?: string,
    companyCode?: string,
    type?: string
  ) {
    this.accountNumber = accountNumber;
    this.companyName = companyName;
    this.commissionCode = commissionCode;
    this.branchPlant = branchPlant;
    this.companyCode = companyCode;
    this.type = type;
  }
}
